export function showView(tenantId: string, canViewAttachment:boolean) {
    const validTenantIds = new Set(['1001', '1002', '1003', '1004', '125', '126', '130', '131', '105']);
    return validTenantIds.has(tenantId) ? canViewAttachment : true;
}

export function IsVIMarket(tenantId: string) {
    const validTenantIds = new Set(['1001', '1002', '1003', '1004', '125', '126', '130', '131', '105']);
    return validTenantIds.has(tenantId);
}
